import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, FormControl, ControlLabel, Button, ListGroup, ListGroupItem, Row, Col } from 'react-bootstrap'
import Confirm from 'react-confirm-bootstrap'
import { toJS } from 'mobx'
import * as helpers from '../lib/HelperFunctions'
import Logger from '../stores/Logger'
import { INVITEE_PHOTOURL } from '../stores/IdeaStore'
import '../components/css/IdeaSharingField.css'
import { observer, inject } from 'mobx-react'

class IdeaSharingField extends Component {
    constructor(props) {
        super(props)
        this.checkIfAdmin = this.checkIfAdmin.bind(this)
        this.addTeamAsMember = this.addTeamAsMember.bind(this)
        this.state = {
            email: '',
            fullName: '',
            responsibleEmail: '',
            responsibleName: '',
        }
    }

    addTeamMember() {
        var team = toJS(this.props.team)
        var canAddTeamMember = true
        var email = this.state.email.toLowerCase()
        const { stores } = this.props
        const { store, authStore } = stores
        email = email.replace(/\s/g, "")

        if(authStore.authUser().email.toLowerCase() === email.toLowerCase()) {
            store.infoAlert = `You are already the owner of this idea`
                window.setTimeout(() => {
                    store.infoAlert = undefined
                }, 3000)
        }
        if (team) {
            canAddTeamMember = (team.length < this.props.maxCollaborators) ? true : false
        }
        if (canAddTeamMember) {
            if (helpers.validateEmail(email)) {
                let nameOfUnknownUser = email.split('@')[0]
                Logger.trackEvent('invitedFriend', 'invitee_email', email.replace(/@/g, "(AT)"))
                let name = this.state.fullName ? this.state.fullName : nameOfUnknownUser
                this.props.onAddTeamMember(email, name)
                this.setState({ email: '', fullName: '' })
            }
            else {
                Logger.trackEvent('invitedFriendFailed', 'email verification failed', email.replace(/@/g, "(AT)"))
            }
        } else {
            Logger.trackEvent('invitedFriendFailed', 'maxCollaborators reached', email.replace(/@/g, "(AT)"))
        }
    }
    addResponsible() {
        const { stores } = this.props
        const { store, authStore } = stores
        if(authStore.authUser().email.toLowerCase() === this.state.responsibleEmail.toLowerCase()) {
            store.infoAlert = `You are already the owner of this idea`
                window.setTimeout(() => {
                    store.infoAlert = undefined
                }, 3000)
        }
        if (helpers.validateEmail(this.state.responsibleEmail)) {
            var email = this.state.responsibleEmail.toLowerCase()
            Logger.trackEvent('invitedFriend', 'invitee_email', email.replace(/@/g, "(AT)"))

            let nameOfUnknownUser = email.split('@')[0]
            let name = this.state.responsibleName ? this.state.responsibleName : nameOfUnknownUser
            this.props.onAddResponsible(email, name)
            this.setState({ responsibleEmail: '', responsibleName: '' })
        }
    }
    addTeamAsMember(newTeam) {
        Logger.trackEvent('addTeamAsMember', 'team', newTeam.teamKey)
        this.props.onAddTeamAsMember(newTeam)
    }
    onRemoveTeamMember(memberEmail, sharedDeleteType) {
        Logger.trackEvent('onRemoveTeamMember', 'removed_email', memberEmail.replace(/@/g, "(AT)"))
        this.props.onRemoveTeamMember(memberEmail, sharedDeleteType)
    }
    onRemoveTeamFromIdea(teamId) {
        Logger.trackEvent('onRemoveTeamFromIdea', 'team', teamId.teamKey)
        this.props.onRemoveTeamFromIdea(teamId)
    }
    onLeaveIdea(sharedDeleteType) {
        Logger.trackEvent('onLeaveIdea', 'responsible', sharedDeleteType)
        this.props.onLeaveTeam(sharedDeleteType)
    }
    onSharingChange(e) {
        if (e.key === 'Enter') {
            this.addTeamMember()
        } else {
            this.setState({ email: e.target.value })
        }
    }
    onFullNameChange(e) {
        if (e.key === 'Enter') {
            this.addTeamMember()
        } else {
            this.setState({ fullName: e.target.value })
        }
    }
    onResponsibleChange(e) {
        if (e.key === 'Enter') {
            this.addResponsible()
        } else {
            this.setState({ responsibleEmail: e.target.value })
        }
    }
    onResponsibleNameChange(e) {
        if (e.key === 'Enter') {
            this.addResponsible()
        } else {
            this.setState({ responsibleName: e.target.value })
        }
    }
    checkIfAdmin(memberId) {
        if (this.props.teamAdminsList !== undefined) {
            Object.keys(this.props.teamAdminsList).forEach((adminId, newIndex) => {
                if (adminId === memberId) {
                    return false
                }
                else if (adminId === this.props.userId) {
                    return true
                }
                else if (Object.keys(this.props.teamAdminsList).length - 1 === newIndex) {
                    return true
                }
            })

        }
        else {
            return true
        }
    }
    render() {
        var team = toJS(this.props.team)
        var canAddTeamMember = true
        var myTeam = toJS(this.props.primaryTeam)
        let existingTeam = []
        let isTeamMember = -1
        let theResponsible = null
        let teamAsCollaboratorKey = ''
        let isTeamAdmin = false
        let responsibleEmail = ''
        if (this.props.teamAdminsList !== undefined) {
            Object.keys(this.props.teamAdminsList).forEach((adminId, newIndex) => {
                if (adminId === this.props.userId) {
                    isTeamAdmin = true
                }
            })
        }
        if (this.props.responsible !== undefined) {
            theResponsible = this.props.responsible
            responsibleEmail = theResponsible.email
        }
        if (team) {
            for (let collaborator of team) {
                if (collaborator.hasOwnProperty('teamId')) {
                    teamAsCollaboratorKey = collaborator.teamId
                }
            }
        }
        if (this.props.ideaTeamOwners) {
            for (let user in this.props.ideaTeamOwners.members) {
                if (this.props.userId === user && isTeamMember === -1) {
                    isTeamMember = 0
                }
            }
        }
        var canAddTeamAsMember = myTeam ? true : false
        this.props.fetchedTeams.forEach((team, index) => {
            if (this.props.team !== undefined) {
                this.props.team.forEach(ideaTeam => {
                    if (ideaTeam.hasOwnProperty('teamId')) {
                        if (ideaTeam.teamId === team.teamKey) {
                            existingTeam[index] = 0
                        }
                    }
                })
            }
        })
        return (
            <FormGroup controlId='formIdeaSharing'>
                {this.props.label &&
                    <ControlLabel>{this.props.label}</ControlLabel>
                }
                <Row>
                    {(team && team.length > 0) &&
                        <div>
                            <span className='collaboratorText'>Current collaborators on this idea</span>
                            <ListGroup fill>
                                {team.map((member, index) =>
                                    <ListGroupItem key={index} className='sharingList'>
                                        <Row className='sharingRow'>
                                            {!member.teamId &&
                                                <Col className='collaboratorImageWrapper' lg={2} md={2} xs={2} sm={2}>
                                                    <img
                                                        onError={(e)=>{helpers.onImageError(e, member.fullName)}}
                                                        src={member.photoURL}
                                                        className='collaboratorImage'
                                                        alt={member.fullName}
                                                    />
                                                </Col>
                                            }
                                            {member.teamId &&
                                                <Col className='collaboratorTeamImageWrapper' lg={2} md={2} xs={2} sm={2}>
                                                    <div className='collaboratorTeamImageContainer'>
                                                        <img
                                                            onError={(e)=>{helpers.onImageError(e, member.fullName)}}
                                                            src={member.photoURL}
                                                            className='collaboratorTeamImage'
                                                            alt={member.fullName}
                                                        />
                                                    </div>
                                                </Col>
                                            }
                                            <Col className='sharingName' lg={5} md={5} xs={5} sm={7}>
                                                {(member.fullName && member.teamId) &&
                                                    <span>
                                                        {member.fullName} (team)
                                                </span>
                                                }
                                                {(member.fullName && !member.teamId) &&
                                                    <span>
                                                        {member.fullName} ({member.email})
                                                </span>
                                                }
                                                {member.fullName === '' &&
                                                    <span>
                                                        {member.email}
                                                    </span>
                                                }
                                            </Col>
                                            <Col xsHidden lg={7} md={6} xs={1} sm={3}>
                                                <small style={{ paddingTop: 9 + 'px' }} className='pull-right'>
                                                    {member.photoURL === INVITEE_PHOTOURL &&
                                                        <p>Invited</p>
                                                    }
                                                </small>
                                            </Col>
                                            {((this.props.isOwner || (isTeamAdmin === true && this.props.userMail !== member.email) || (theResponsible !== null && this.props.userMail === theResponsible.email)) && !member.teamId) &&
                                                <Col className='removeButtonContainer' lg={1}>
                                                    <Confirm
                                                        onConfirm={this.onRemoveTeamMember.bind(this, member.email, 'team')}
                                                        body='Are you sure you want to remove this team member?'
                                                        confirmText='Remove team member'
                                                        title='Remove team member'>
                                                        <Button bsSize='small'>Remove</Button>
                                                    </Confirm>
                                                </Col>
                                            }
                                            {((this.props.isOwner || isTeamAdmin === true || (theResponsible !== null && this.props.userMail === theResponsible.email)) && member.teamId) &&
                                                <Col className='removeButtonContainer' lg={1}>
                                                    <Confirm
                                                        onConfirm={this.onRemoveTeamFromIdea.bind(this, member.teamId)}
                                                        body='Are you sure you want to remove your whole team from this idea?'
                                                        confirmText='Remove team'
                                                        title='Remove team'>
                                                        <Button bsSize='small'>Remove</Button>
                                                    </Confirm>
                                                </Col>
                                            }
                                            {(this.props.userMail === member.email) && (this.props.userMail !== responsibleEmail) &&
                                                <Col className='leaveButtonContainer' lg={1} md={1}>
                                                    <Confirm
                                                        onConfirm={this.onLeaveIdea.bind(this, 'team')}
                                                        body='Are you sure you want to leave this idea?'
                                                        confirmText='Leave idea'
                                                        title='Leave Idea'>
                                                        <Button bsSize='small'>Leave</Button>
                                                    </Confirm>
                                                </Col>
                                            }
                                        </Row>
                                    </ListGroupItem>,
                                )}
                            </ListGroup>
                        </div>
                    }
                </Row>
                {this.props.ideaTeamKey && (((this.props.isOwner && this.props.primaryTeam.hasOwnProperty('key') && this.props.primaryTeam.key !== undefined) || (isTeamAdmin === true && isTeamMember === 0) || (theResponsible !== null && theResponsible.userId === this.props.userId && isTeamMember === 0)) && teamAsCollaboratorKey === '') &&
                    <div>
                        <Row style={{ marginBottom: 20 + 'px' }}>
                            <span className='inviteText'>Invite your team to contribute</span>
                        </Row>
                        <Row>
                            {this.props.fetchedTeams && this.props.fetchedTeams.map((team, index) =>
                                <div key={index}>
                                    {(this.props.teamIdeaKey !== null && this.props.ideaTeamKey && this.props.ideaTeamKey === team.teamKey) &&
                                        <div style={{ overflow: 'auto', marginBottom: 10 + 'px' }}>
                                            <Col key={index + 1} sm={9} xs={6}>
                                                <div className='ideaPageTeamPhotoContainer'><img alt='Team' src={team.teamPhoto} className='ideaPageTeamPhoto' /></div>
                                                <div className='ideaPageTeamName' key={index + 2}>{team.teamName}</div>
                                            </Col>
                                            <Col key={index + 3} sm={3} xs={6}>
                                                <FormGroup key={index + 4}>
                                                    <ControlLabel key={index + 5}>&nbsp;</ControlLabel>
                                                    <Button key={index + 6} onClick={() => this.addTeamAsMember(team.teamKey)} disabled={!canAddTeamAsMember} bsStyle='primary' className='pull-right'>Invite Team</Button>
                                                </FormGroup>
                                            </Col>
                                        </div>
                                    }
                                </div>,
                            )}
                        </Row>
                    </div>
                }
                {(this.props.isOwner || isTeamAdmin || (theResponsible !== null && this.props.userMail === theResponsible.email)) &&
                    <div>
                        <Row style={{ marginTop: 10 + 'px' }}>
                            <span className='inviteText'>Invite more people to contribute</span>
                        </Row>
                        <Row style={{ position: 'relative', marginTop: 10 + 'px' }}>
                            <Col lg={6} sm={6}>
                                <FormGroup>
                                    <ControlLabel>E-mail</ControlLabel>
                                    <FormControl
                                        type='text'
                                        value={this.state.email}
                                        placeholder='colleague@company.com'
                                        onChange={this.onSharingChange.bind(this)}
                                        onKeyPress={this.onSharingChange.bind(this)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg={5} sm={5}>
                                <FormGroup>
                                    <ControlLabel>Name</ControlLabel>
                                    <FormControl
                                        type='fullName'
                                        value={this.state.fullName}
                                        placeholder='Jane Doe'
                                        onChange={this.onFullNameChange.bind(this)}
                                        onKeyPress={this.onFullNameChange.bind(this)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className='ideaPageInviteButton' lg={1} sm={1}>
                                <FormGroup>
                                    <ControlLabel style={{ display: 'block' }}>&nbsp;</ControlLabel>
                                    <Button onClick={this.addTeamMember.bind(this)} disabled={!canAddTeamMember} bsStyle='primary' className='pull-right'>Invite</Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                }
                {((this.props.isOwner && this.props.responsible === undefined) || (isTeamAdmin === true && this.props.responsible === undefined)) &&
                    <div>
                        <Row style={{ marginTop: 10 + 'px' }}>
                            <span className='inviteText'>Assign another person to be responsible to your idea</span>
                        </Row>
                        <Row style={{ marginTop: 10 + 'px' }}>
                            <Col style={{ display: 'inline-block' }} lg={6} sm={6}>
                                <FormGroup>
                                    <ControlLabel>E-mail</ControlLabel>
                                    <FormControl
                                        type='text'
                                        value={this.state.responsibleEmail}
                                        placeholder='colleague@company.com'
                                        onChange={this.onResponsibleChange.bind(this)}
                                        onKeyPress={this.onResponsibleChange.bind(this)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg={5} sm={5}>
                                <FormGroup>
                                    <ControlLabel>Name</ControlLabel>
                                    <FormControl
                                        type='fullName'
                                        value={this.state.responsibleName}
                                        placeholder='Jane Doe'
                                        onChange={this.onResponsibleNameChange.bind(this)}
                                        onKeyPress={this.onResponsibleNameChange.bind(this)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col style={{ display: 'inline-block' }} className='ideaPageInviteButton' lg={1} sm={1}>
                                <FormGroup>
                                    <ControlLabel style={{ display: 'block' }}>&nbsp;</ControlLabel>
                                    <Button onClick={this.addResponsible.bind(this)} disabled={!canAddTeamMember} bsStyle='primary' className='pull-right'>Invite</Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                }
                {this.props.responsible !== undefined &&
                    <div style={{ marginTop: 15 + 'px' }}>
                        <Row>
                            <span className='collaboratorText'>Responsible</span>
                            <ListGroup fill>
                                <ListGroupItem key={5} className='sharingList'>
                                    <Row className='sharingRow'>
                                        <Col className='collaboratorImageWrapper' lg={2} md={2} xs={2} sm={2}>
                                            <img
                                                onError={(e)=>{helpers.onImageError(e, theResponsible.fullName)}}
                                                src={theResponsible.photoURL}
                                                className='collaboratorImage'
                                                alt={theResponsible.fullName}
                                            />
                                        </Col>
                                        <Col className='sharingName' lg={5} md={5} xs={5} sm={7}>
                                            {(theResponsible.fullName && !theResponsible.teamId) &&
                                                <span>
                                                    {theResponsible.fullName} ({theResponsible.email})
                                                </span>
                                            }
                                            {theResponsible.fullName === '' &&
                                                <span>
                                                    {theResponsible.email}
                                                </span>
                                            }
                                        </Col>
                                        <Col xsHidden lg={7} md={6} xs={1} sm={3}>
                                            <small style={{ paddingTop: 9 + 'px' }} className='pull-right'>
                                                {theResponsible.photoURL === INVITEE_PHOTOURL &&
                                                    <p>Invited</p>
                                                }
                                            </small>
                                        </Col>
                                        {(this.props.isOwner || (isTeamAdmin === true && this.props.userMail !== theResponsible.email)) &&
                                            <Col className='removeButtonContainer' lg={1}>
                                                <Confirm
                                                    onConfirm={this.onRemoveTeamMember.bind(this, theResponsible.email, 'responsible')}
                                                    body='Are you sure you want to remove the responsible?'
                                                    confirmText='Remove responsible'
                                                    title='Remove team member'>
                                                    <Button bsSize='small'>Remove</Button>
                                                </Confirm>
                                            </Col>
                                        }
                                        {this.props.userMail === theResponsible.email &&
                                            <Col className='leaveButtonContainer' lg={1} md={1}>
                                                <Confirm
                                                    onConfirm={this.onLeaveIdea.bind(this, 'responsible')}
                                                    body='Are you sure you want to leave this idea?'
                                                    confirmText='Leave idea'
                                                    title='Leave Idea'>
                                                    <Button bsSize='small'>Leave</Button>
                                                </Confirm>
                                            </Col>
                                        }
                                    </Row>
                                </ListGroupItem>
                            </ListGroup>
                        </Row>
                    </div>
                }
            </FormGroup>
        )
    }
}
IdeaSharingField.propTypes = {
    team: PropTypes.object,
    primaryTeam: PropTypes.object,
    fetchedTeams: PropTypes.object,
    onAddTeamMember: PropTypes.func.isRequired,
    onAddTeamAsMember: PropTypes.func.isRequired,
    onLeaveTeam: PropTypes.func.isRequired,
    onRemoveTeamMember: PropTypes.func.isRequired,
    onRemoveTeamFromIdea: PropTypes.func.isRequired,
    maxCollaborators: PropTypes.number.isRequired,
    ideaTeamOwners: PropTypes.object,
    label: PropTypes.string,
    teamAdminsList: PropTypes.object.isRequired,
    isOwner: PropTypes.bool.isRequired,
    ideaTeamKey: PropTypes.string,
    userMail: PropTypes.string.isRequired,
    responsible: PropTypes.object,
    userId: PropTypes.string,
}

export default inject("stores")(observer(IdeaSharingField))



// WEBPACK FOOTER //
// ./src/components/IdeaSharingField.js